export default __webpack_public_path__ + "static/media/a037-student-2.ca4777cb.png";